import { useTranslation } from "react-i18next";
import { Button, Grid, GridColumn } from "semantic-ui-react";

import { DATE_FORMATS_FNS, UploadProfile } from "components";
import { useSelectedDealer } from "components/DealersAndLocationsDropdown/hooks";
import ENV from "config/Env";
import { usePermanentRealTimeUser } from "hooks";
import { createFormHelper } from "lib/Form";
import { formatDate } from "utils/dateHelperFunctions";

import type { User } from "models";

type MyAccountSectionProps = {
  onChangePassword: () => void;
  onProfilePictureChange: (url: string) => void;
};

const FormHelper = createFormHelper<User>();

export const MyAccountSection = ({ onChangePassword, onProfilePictureChange }: MyAccountSectionProps) => {
  const { t } = useTranslation();

  const { user } = usePermanentRealTimeUser();
  const { selectedDealer } = useSelectedDealer();
  const { setValue } = FormHelper.useFormContext();

  const handleProfilePictureChange = (url: string) => {
    setValue("profile_picture", url || "");
    onProfilePictureChange(url);
  };

  return (
    <div className="setting_section">
      <div className="personal_setting">
        <span>
          <UploadProfile
            formId="user-profile"
            path="/users/profile_picture/upload"
            baseURL={ENV.systemBaseURL}
            locationPath={`${selectedDealer?.id}_${selectedDealer?.name}/${formatDate(user?.created_on ?? new Date(), DATE_FORMATS_FNS.yearMonthDateSlash)}/${user?.id}_${user?.last_name}`}
            user={user}
            onSuccess={handleProfilePictureChange}
          />
        </span>
        <h1>{t("v8_my_account", "My account")}</h1>
      </div>
      <h2>{t("v8_personal", "Personal")}</h2>
      <Grid columns={3}>
        <GridColumn>
          <label className="input-label">{t("v8_first_name", "First name")}</label>
          <FormHelper.Field.Input
            name="first_name"
            inputProps={{
              disabled: true,
              fluid: true,
              placeholder: t("v8_first_name", "First name")
            }}
          />
        </GridColumn>
        <GridColumn>
          <label className="input-label">{t("v8_last_name", "Last Name")}</label>
          <FormHelper.Field.Input
            name="last_name"
            inputProps={{
              disabled: true,
              fluid: true,
              placeholder: t("v8_last_name", "Last name")
            }}
          />
        </GridColumn>
        <GridColumn>
          <label className="input-label">{t("v8_username", "Username")}</label>
          <FormHelper.Field.Input
            name="username"
            inputProps={{
              disabled: true,
              fluid: true,
              placeholder: t("v8_username", "Username")
            }}
          />
        </GridColumn>
      </Grid>
      <Grid columns={3}>
        <GridColumn>
          <label className="input-label">{t("v8_email", "Email")}</label>
          <FormHelper.Field.Input
            name="email"
            inputProps={{
              disabled: true,
              fluid: true,
              placeholder: t("v8_email", "Email")
            }}
          />
        </GridColumn>
        <GridColumn>
          <label className="input-label">{t("v8_phone", "Phone")}</label>
          <FormHelper.Field.Input
            name="phone"
            inputProps={{
              fluid: true,
              placeholder: t("v8_phone", "Phone")
            }}
          />
        </GridColumn>
        <GridColumn>
          <label className="input-label">{t("v8_mobile", "Mobile")}</label>
          <FormHelper.Field.Input
            name="mobile"
            inputProps={{
              fluid: true,
              placeholder: t("v8_mobile", "Mobile")
            }}
          />
        </GridColumn>
      </Grid>
      <div className="my_role">
        <h2 className="section-title">{t("v8_my_role", "My role")}</h2>
        <div className="my_role_container">
          <div className="my_role_container_item">
            <span className="user-role">{user?.role_name}</span>
          </div>
          <div className="my_role_container_item">
            <label>&nbsp;</label>
            <Button type="button" size="medium" color="green" fluid className="change-password" onClick={onChangePassword}>
              {t("v8_change_password", "Change Password")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
